import "./Loading.css";
import { useGlobalState  } from "../../Contexts/GlobalStateContext";
import { Modal } from "react-bootstrap";

const ErrorModal = () => {
  const { isLoading, setErrorVisible, setNetworkErrorVisible, errorMessage } = useGlobalState();
  if (!isLoading) return null;

  return (
    <Modal show={isLoading} onHide={setErrorVisible || setNetworkErrorVisible} centered className="loading-modal">
      <div className="loading-spinner"></div>
    </Modal>
  );
};

export default ErrorModal;
